import clsx from 'clsx';
import popularImg from '../../images/popular.png';
import banreservasImg from '../../images/banreservas.png';
import BHDImg from '../../images/bhd.png';
import { useBusiness } from '@recargas-dominicanas/core/store';
import { Balance } from '../../components/balance/balance.component';

import {
  PageContainer,
  PageContent,
  PageToolbar,
  Title,
  Icon,
  OutlineCard,
  Text,
  CopyButton
} from '@recargas-dominicanas/core/components';

import { style } from './topup-balance.module.css';

export function TopupBalance() {

  const business = useBusiness().get();

  const bankAccounts = [
    { name: 'Banreservas', account: '9607208524', image: banreservasImg },
    { name: 'Banco Popular', account: '840900617', image: popularImg },
    { name: 'Banco BHD', account: '36354790015', image: BHDImg }
  ];

  return (
    <PageContainer className={style.container}>
      <PageToolbar className={style.toolbar}>
        <Title
          style={style.title}
          title='Comprar balance' />
        <Balance/>
      </PageToolbar>
      <PageContent className={style.content}>
        <div className={style.column}>
          <OutlineCard className={style.outlineCard}>
            <div className={style.sectionHeaderWithIcon}>
              <Icon icon='badge' className={style.headerIcon} />
              <div className={style.sectionHeader}>
                <Text className={style.sectionTitle} text='Tu ID de referencia' />
                <Text className={style.sectionSubtitle} text='Usa este ID como referencia o concepto en tu depósito o transferencia.' />
              </div>
            </div>
            <div className={style.idCard}>
              <div className={style.idInfo}>
                <span className={style.idLabel}>ID del negocio</span>
                <span className={style.idValue}>{business.id || '---'}</span>
              </div>
              <CopyButton
                className={style.copyButton}
                text={business.id?.toString() || ''} />
            </div>
          </OutlineCard>
          <OutlineCard className={style.outlineCard}>
            <div className={style.sectionHeaderWithIcon}>
              <Icon icon='receipt_long' className={style.headerIcon} />
              <div className={style.sectionHeader}>
                <Text className={style.sectionTitle} text='Cómo recargar tu balance' />
                <Text className={style.sectionSubtitle} text='Sigue estos pasos para que podamos aplicar tu depósito o transferencia correctamente.' />
              </div>
            </div>
            <div className={style.stepsList}>
              <div className={style.stepItem}>
                <div className={style.stepNumber}>1</div>
                <div className={style.stepText}>
                  Realiza un depósito o transferencia a cualquiera de nuestras cuentas bancarias. Monto mínimo: <b>RD$ 500</b>.
                </div>
              </div>
              <div className={style.stepItem}>
                <div className={style.stepNumber}>2</div>
                <div className={style.stepText}>
                  Coloca tu <b>ID {business.id}</b> como referencia o concepto al momento de realizar el pago.
                </div>
              </div>
              <div className={style.stepItem}>
                <div className={style.stepNumber}>3</div>
                <div className={style.stepText}>
                  Envíanos una foto del comprobante junto con tu ID por WhatsApp para poder asignar tu balance.
                </div>
              </div>
            </div>
          </OutlineCard>
          <OutlineCard className={clsx(style.outlineCard, style.contactCard)}>
            <div className={style.sectionHeaderWithIcon}>
              <Icon icon='support_agent' className={style.headerIcon} />
              <div className={style.sectionHeader}>
                <Text className={style.sectionTitle} text='¿Necesitas asistencia?' />
                <Text className={style.sectionSubtitle} text='Escríbenos si tienes dudas o algún inconveniente con tu depósito o transferencia.' />
              </div>
            </div>
            <div className={style.contactList}>
              <div className={style.contactItem}>
                <Icon icon='phone' className={style.contactIcon} />
                <div className={style.contactText}>
                  <span className={style.contactLabel}>Teléfono / WhatsApp</span>
                  <a href='https://wa.me/18298711132' target='_blank' rel='noopener noreferrer' className={style.contactValue}>(829) 871-1132</a>
                </div>
              </div>
            </div>
          </OutlineCard>
        </div>
        <OutlineCard className={clsx(style.outlineCard, style.bankAccountsCard)}>
          <div className={style.sectionHeaderWithIcon}>
            <Icon icon='account_balance' className={style.headerIcon} />
            <div className={style.sectionHeader}>
              <Text className={style.sectionTitle} text='Cuentas bancarias' />
              <div className={style.sectionSubtitle}>
                Puedes comprar balance en cualquiera de nuestras cuentas bancarias. Todas las cuentas están a nombre de <b>Recargas Dominicanas Redomi EIRL</b>.
              </div>
            </div>
          </div>
          <div className={style.bankList}>
            {bankAccounts.map(bank => (
              <div key={bank.name} className={style.bankRow}>
                <div className={style.bankLeft}>
                  <img src={bank.image} className={style.bankLogo} alt={bank.name} />
                  <div className={style.bankDetails}>
                    <span className={style.bankName}>{bank.name}</span>
                    <span className={style.bankAccount}>{bank.account}</span>
                  </div>
                </div>
                <CopyButton text={bank.account.replace(/-/g, '')} />
              </div>
            ))}
          </div>
        </OutlineCard>
      </PageContent>
    </PageContainer>
  );
}
